import React, { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Table,
  UncontrolledTooltip,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap";
import { putUsersAdminStatus, getUsersAdmin, getUsersAdminRolesList, getOrgsAdmin } from "../../helpers/api_rombo_helper";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import { map } from "lodash";
import { listStatusUsers } from "../../common/data";
import Select from "react-select";
import BreadcrumbLink from "../../components/Common/BreadcrumbLink";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import DeleteModal from "./DeleteModal";
import DeleteBulkModal from "./DeleteBulkModal";
import i18n from "../../i18n";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "../../components/Common/Spinner";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import { UserActions, Permissions } from "../../constants/enums";
import { orgId } from "../../constants/utils";

const AdminUsers = () => {
  document.title = `${i18n.t("Users")} - ${orgId}`;

  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleViewModalDelete = () => setDeleteModal(!deleteModal);
  const [listCompanies, setListCompanies] = useState([]);
  const [deleteBulkModal, setDeleteBulkModal] = useState(false);
  const toggleViewModalDeleteBulk = () => setDeleteBulkModal(!deleteBulkModal);
  const [clickUser, setClickUser] = useState({});
  const [rol, setRol] = useState("");
  const [status, setStatus] = useState("");
  const [fCompany, setFCompany] = useState(null);
  const [clickArrUser, setClickArrUser] = useState(UserActions.ADD_USER);
  const [checkArrUsers, setCheckArrUsers] = useState([]);
  const [users, setUsers] = useState({});
  const [findUsers, setFindUsers] = useState([]);
  const [opts, setOpts] = useState({});
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [reloadUsers, setReloadUsers] = useState(false);
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);
  const [isLoading, setLoading] = useState(true);
  const [drp_link, setDrp_link] = useState(false);
	const [infoUser, setInfoUser] = useState({ permissions: [] });

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);
  
  useEffect(() => {
    if(infoUser.is_staff) onGetOrgsAdmin()
  }, [infoUser]);

  useEffect(() => {
    var newOpts = {
      name: autoformik.values.search,
      email: autoformik.values.email,
      roles: rol,
      company_id: fCompany,
      status: status,
      page: 1,
      size: 10
    }
    onGetUsersAdmin(newOpts)
    if(localStorage.getItem("notify") == "true"){
      setShowAlertSuccess(true)
      setTextHeader(localStorage.getItem("headerText"))
      setTextBody(localStorage.getItem("bodyText"))
      localStorage.setItem("notify", "false")
    }
    onGetUsersAdminRolesList()
  }, [dispatch, clickArrUser, reloadUsers]);

  const onGetUsersAdminRolesList = () => {
    let arr = [];
    getUsersAdminRolesList(token)
      .then((response) => {
        map(response, (item, key) => 
          arr.push({ value: item.name, label: item.description })
        );
        setRoles([...arr]);
      });
  };

  const onGetUsersAdmin = (newOpts = { page: 1, size: 10 }) => {
    setFindUsers([]);
    
    getUsersAdmin(token, newOpts)
      .then((response) => {
        setUsers(response);
        setFindUsers([...response.items]);
        setOpts(newOpts);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getUsersAdmin - ", error);
      });
  };  

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string()
    })
  });

  const onClickArrUser = (user, type, e) => {
    if (type === "one") {
      setCheckArrUsers((prev) => {
        if (e.target.checked) {
          return [...prev, user];
        } 
        return prev.filter((u) => u.id !== user.id);
      });
    } else {
      if (e.target.checked) {
        setCheckArrUsers([...findUsers]);
      } else {
        setCheckArrUsers([]);
      }
    }
  };  

  const onChangePagePaginate = (page) => {
    const newOpts = {
      name: autoformik.values.search,
      email: autoformik.values.email,
      roles: rol,
      partner_id: fCompany,
      status: status,
      page: page,
      size: 10,
    };
  
    onGetUsersAdmin(newOpts);
  };  

  const changeStatusUser = (type) => {
    checkArrUsers.map((item, index) => {
      document.getElementById(`check-${item.id}`).checked = false;
      putUsersAdminStatus(token, item.id, {
        params: { type: type },
        headers: { ...token }
      })
        .then((response) => {
          setReloadUsers(true);
          setShowAlertSuccess(true);
          setCheckArrUsers([]);
          setClickArrUser("add_user");
          setStatus(null);
          setTextHeader(i18n.t("UpdatedStatusUsersSuccessfully"));
          setTextBody(i18n.t("SuccessUpdateStatus", { status_name: i18n.t(type) }));
        })
        .catch((error) => {
          console.error("Error - putUsersAdminStatus - ", error);
          if (error.code == 500) setErrorAlertMessage(i18n.t("NetworkError"));
        });
    });
  };

  const onClickDelete = (user) => {
    setClickUser(user);
    setDeleteModal(true);
  };  

  const searchFilters = (value, type) => {
    const newOpts = {
      name: type === "name" ? value : autoformik.values.search,
      email: type === "email" ? value : autoformik.values.email,
      roles: rol,
      partner_id: fCompany,
      status: status,
      page: 1,
      size: 10,
    };
  
    onGetUsersAdmin(newOpts);
  };  

  const onClickChancheStatus = (type) => {
    let newStatus = '';
    
    switch (type) {
      case UserActions.ADD_USER:
        newStatus = null;
        break;
      case UserActions.DELETE_USER:
        newStatus = null;
        break;
      case UserActions.ACTIVATE_USER:
        newStatus = "INACTIVE";
        break;
      case UserActions.DEACTIVATE_USER:
        newStatus = "ACTIVE";
        break;
      default:
        newStatus = '';
    }
    
    setStatus(newStatus);
    setClickArrUser(type);
  };

  const onGetOrgsAdmin = () => {
    let arr = []
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const onChangeFilters = (type, e) => {
    let val = e ? e.value : "";
    type == "rol" && setRol(val)
    type == "status" && setStatus(val)
    var newOpts = {
      name: autoformik.values.search,
      email: autoformik.values.email,
      roles: type == "rol" ? val : rol,
      status: type == "status" ? val : status,
      partner_id: type == "company" ? val : fCompany,
      page: 1,
      size: 10
    }
    onGetUsersAdmin(newOpts)
  }

  const getNamesRoles = (userRoles) => {
    let names = "";
    (userRoles ? userRoles.split(",") : []).map((rol, key) => {
      var fRol = roles.filter((ele) => ele.value.trim() == rol.trim()).shift();
      userRoles.split(",").length != key + 1 && (fRol ? (names += `${fRol.label}, `) : null);
      userRoles.split(",").length == key + 1 && (fRol ? (names += `${fRol.label}`) : null);
    });
    return names;
  };

  return (
    <Fragment>
      <div className="page-content">
        <BreadcrumbLink
          title={i18n.t("Users")}
          link='/users'
          breadcrumbItem={i18n.t("AdminUsers")}
        />
        <Card>
          <CardBody className="pb-2">
            <Row className="pb-2">
              <Col xs={12} xxl={12} md={12} className="pb-2">
                <Row>
                  <Col xxl={9} md={7} xs={12}>
                    <CardTitle className="h4">{i18n.t("Users")}</CardTitle>
                  </Col>
                  <Col xxl={12} className="d-flex justify-content-end align-items-start mb-4">
                    <Row className="d-flex justify-content-end">
                      <Col xxl={6} md={6} xs={6}>
                        <DeleteBulkModal
                          checkArrUsers={checkArrUsers}
                          token={token}
                          setReloadUsers={setReloadUsers}
                          reloadUsers={reloadUsers}
                          setCheckArrUsers={setCheckArrUsers}
                          isOpen={deleteBulkModal}
                          toggle={toggleViewModalDeleteBulk}
                          setDeleteBulkModal={setDeleteBulkModal}
                          setShowAlertSuccess={setShowAlertSuccess}
                          setTextHeader={setTextHeader}
                          setTextBody={setTextBody}
                        />
                        {clickArrUser == UserActions.ADD_USER && infoUser.permissions.includes(Permissions.USERS_CREATE) ? (
                          <Link to={'create'} className="btn btn-request">
                            {i18n.t("AddNewUser")}
                          </Link>
                        ) : null}
                        {clickArrUser == UserActions.DELETE_USER ? (
                          <button onClick={toggleViewModalDeleteBulk} className="btn btn-request button-margin-left">
                            {i18n.t("DeleteUser")}
                          </button>
                        ) : null}
                        {clickArrUser == UserActions.ACTIVATE_USER ? (
                          <button className="btn btn-request me-2" onClick={() => changeStatusUser("ACTIVE")}>
                            {i18n.t("ActivateUser")}
                          </button>
                        ) : null}
                        {clickArrUser == UserActions.DEACTIVATE_USER ? (
                          <button className="btn btn-request button-margin-maxleft" onClick={() => changeStatusUser("INACTIVE")}>
                            {i18n.t("DeactivateUser")}
                          </button>
                        ) : null}
                      </Col>
                      {
                        clickArrUser !== "add_user" ? (
                          <Col xxl={4} md={4} xs={6}>
                            <button
                              onClick={() => {
                                setCheckArrUsers([]);
                                setClickArrUser("add_user");
                              }}
                               className="btn btn-go-back border me-5"
                            >
                              {i18n.t("GoBack")}
                            </button>
                          </Col>
                        ) : (
                          <Col xxl={4} md={4} xs={6}>
                            {/* <Col xxl={6} md={6} xs={6}>
                              <button className="btn btn-light">o</button>
                            </Col> */}
                            <Col xxl={6} md={6} xs={6}>
                              <ButtonDropdown isOpen={drp_link} toggle={() => setDrp_link(!drp_link)}>
                                <DropdownToggle className="btn btn-employees-options button-margin-minleft button-margin-right" caret color="secondary">
                                  ⋮
                                </DropdownToggle>
                                <DropdownMenu className="custom-dropdown-menu">
                                  {infoUser.permissions.includes(Permissions.USERS_WRITE) && (
                                    <DropdownItem onClick={() => onClickChancheStatus(UserActions.ACTIVATE_USER)}>
                                      {i18n.t("ActivateUser")}
                                    </DropdownItem>
                                  )}
                                  {infoUser.permissions.includes(Permissions.USERS_WRITE) && (
                                    <DropdownItem onClick={() => onClickChancheStatus(UserActions.DEACTIVATE_USER)}>
                                      {i18n.t("DeactivateUser")}
                                    </DropdownItem>
                                  )}
                                  {infoUser.permissions.includes(Permissions.USERS_DELETE) && (
                                    <DropdownItem onClick={() => setClickArrUser(UserActions.DELETE_USER)}>
                                      {i18n.t("DeleteUser")}
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </ButtonDropdown>
                            </Col>
                          </Col>
                        )
                      }
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} xxl={12} md={12} className="">
              <div className="orange-separator" />
                <Form className="row gy-2 gx-3" onSubmit={autoformik.handleSubmit}>
	                {infoUser.is_staff && (
                    <Col xxl={2} md={2} xs={12}>
                      <Card className="mb-0">
                        <Select
                          name="company"
                          placeholder={i18n.t("Partner")}
                          options={listCompanies}
                          isClearable
                          className="select2-selection"
                          onChange={ (e) => {
                            setFCompany(e?.value)
                            onChangeFilters("company", e)
                          }}
                        />
                      </Card>
	                  </Col>
                  )}
                  <Col xxl={2} md={2} xs={12}>
                    <div className="col-sm-auto">                        
                      <Input
                        type="text"
                        name="search"
                        className="form-control"
                        id="searchInput"
                        placeholder={i18n.t("SearchName")}
                        value={autoformik.values.search}
                        onBlur={(e) => autoformik.handleBlur(e)}
                        onChange={(e) => {
                          autoformik.handleChange(e);
	                          searchFilters(e.target.value, "name")
                        }}
                        invalid={
                          autoformik.touched.search && autoformik.errors.search ? true : false
                        }
                      />
                      {autoformik.errors.search && autoformik.touched.search && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.search}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <div className="col-sm-auto">
                      <Input
                        type="text"
                        name="email"
                        className="form-control"
                        id="emailInput"
                        placeholder={i18n.t("Email")}
                        value={autoformik.values.email}
                        onBlur={(e) => autoformik.handleBlur(e)}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "email");
                         }}
                        invalid={autoformik.touched.email && autoformik.errors.email ? true : false}
                      />
                      {autoformik.errors.email && autoformik.touched.email && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.email}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <Card className="mb-1">
                      <Select
                        name="rol"
                        placeholder={i18n.t("Rol")}
                        options={roles}
                        isClearable
                        className="select2-selection"
                        onChange={(e) => {
                          onChangeFilters("rol", e)
                        }}
                      />
                    </Card>
	                </Col>
                  <Col xxl={2} md={2} xs={12}>
	                  <Card className="mb-2">
                      <Select
                        name="status"
                        placeholder={i18n.t("Status")}
                        options={listStatusUsers}
                        isClearable
                        className="select2-selection"
                        onChange={(e) => {
                          onChangeFilters("status", e)
                        }}
                      />
                    </Card>
                  </Col>
                </Form>
                <div className="orange-separator" />
                <div className="table-responsive pt-3">
                  <Table className="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline table-users">
                    <thead>
                      <tr>
                        <th className="table-header">
                          <Input
                            type="checkbox"
                            id="checkAll"
                            className={`${clickArrUser !== "add_user" ? "" : "d-none p-0 m-0"}`}
                            checked={checkArrUsers.length === findUsers.length && findUsers.length > 0}
                            onChange={(e) => onClickArrUser(null, "all", e)}
                          />
                        </th>
                        <th className="name-column table-header">{i18n.t("Name")}</th>
                        <th className="email-column table-header">{i18n.t("Email")}</th>
                        <th className="phone-column table-header">{i18n.t("Phone")}</th>
                        {infoUser.is_staff && (
                          <th className="partner-column table-header">{i18n.t("Partner")}</th>
                        )}
                        <th className="roles-column table-header">{i18n.t("Roles")}</th>
                        <th className="status-column table-header">{i18n.t("Status")}</th>
                        {(infoUser.permissions.includes(Permissions.USERS_WRITE) ||
                          infoUser.permissions.includes(Permissions.USERS_DELETE)) && (
                          <th className="actions-column table-header">
                            {i18n.t("Actions")}
                          </th>
                        )}
                      </tr>
                    </thead>
                    {
                      isLoading ? null : (
                        <tbody>
                          {findUsers.map((user, key) => (
                            <tr key={key}>
                              <td>
                                <Input
                                  type="checkbox"
                                  id={`check-${user.id}`}
                                  className={`${clickArrUser !== "add_user" ? "" : "d-none p-0 m-0"}`}
                                  checked={checkArrUsers.some((u) => u.id === user.id)}
                                  onChange={(e) => onClickArrUser(user, "one", e)}
                                />
                              </td>
                              <td>{user.full_name}</td>
                              <td>{user.email}</td>
                              <td>{user.phone}</td>
                              {infoUser.is_staff && (
                                <td>{user.partner_name}</td>
                              )}
                              <td>{getNamesRoles(user.roles)}</td>
                              <td>
                                  <div
                                    className={`employee-status ${
                                      user.status === "ACTIVE"
                                        ? "employee-status-active"
                                        : "employee-status-inactive"
                                    }`}
                                  >
                                    {i18n.t(user.status)}
                                  </div>
                                </td>
                                <td>
                              <div className="d-flex">
                                {infoUser.permissions.includes(Permissions.USERS_WRITE) && (
                                  <Link
                                    to={`edit/${user.id}`}
                                    className="btn btn-edit waves-effect waves-light mx-1 edit-button"
                                    id={`edittooltip-${user.id}`}
                                  >
                                    <i className="mdi mdi-pencil font-size-18 edit-icon" />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`edittooltip-${user.id}`}
                                    >
                                      {i18n.t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                )}
                                {infoUser.permissions.includes(Permissions.USERS_DELETE) && (
                                  <button
                                    type="button"
                                    className="btn btn-deleted-request waves-effect waves-light mx-1"
                                    onClick={() => onClickDelete(user)}
                                    id={`deletetooltip-${user.id}`}
                                  >
                                    <i className="mdi mdi-delete font-size-18 deleted-icon" />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`deletetooltip-${user.id}`}
                                    >
                                      {i18n.t("Eliminated")}
                                    </UncontrolledTooltip>
                                  </button>
                                )}
                              </div>
                            </td>
                            </tr>
                          ))}
                        </tbody>
                      )
                    }
                  </Table>
                  {isLoading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                    <PaginationV2
                      currentPage={users.page}
                      pageSize={users.size}
                      totalItems={users.total}
                      onChangePage={onChangePagePaginate}
                    />
                  )}
	                <DeleteModal
                    clickUser={clickUser}
                    token={token}
                    setReloadUsers={setReloadUsers}
                    reloadUsers={reloadUsers}
                    setClickUser={setClickUser}
                    isOpen={deleteModal}
                    toggle={toggleViewModalDelete}
                    setDeleteModal={setDeleteModal}
                    setShowAlertSuccess={setShowAlertSuccess}
                    setTextHeader={setTextHeader}
                    setTextBody={setTextBody}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
      <AlertSuccess
        showAlertSuccess={showAlertSuccess}
        setShowAlertSuccess={setShowAlertSuccess}
        textHeader={textHeader}
        textBody={textBody}
      />
	  </Fragment>
  );
};

AdminUsers.propTypes = {}

export default AdminUsers;
